import KSButton from 'presentation/components/KSButton';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

interface ApplyButtonProps {
  disabled: boolean;
}

function ApplyButton({ disabled }: ApplyButtonProps) {
  return <KSButton label="Apply" color="primary" size="medium" variant="contained" type="submit" disabled={disabled} />;
}

export default ApplyButton;
